import axios from 'axios'

const apiAgent = axios.create({
  timeout: 30000
})

export default apiAgent
